const openDataProps = {
  type: {
    default: "userName",
    type: String
  },
  separate: {
    default: void 0,
    type: [String, Array]
  },
  name: {
    default: "",
    type: String
  },
  mode: {
    default: "name",
    type: String
  },
  isTripartite: {
    type: Boolean,
    default: void 0
  }
};
export {
  openDataProps
};
